<template>
    <div class="demand">
        <div class="searchPart">

            <el-select v-model="consultUuid" placeholder="请选择" >
                <!-- <el-option label="请选择" value=""></el-option> -->
                <el-option label="全部"></el-option>
                <el-option v-for="(item,index) in deliveryTypeList" :key="index" :label="item.name" :value="item.uuid" >
                </el-option>
            </el-select>
            <el-select v-model="status" placeholder="请选择">
                <!-- <el-option label="请选择" value=""> </el-option> -->
                <el-option label="全部" > </el-option>
                <el-option label="未处理" value="UNREAD"> </el-option>
                <el-option label="已处理" value="READ"> </el-option>
            </el-select>
            <el-button class="searchBtn" @click="getList">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <el-table
                :data="tableList"
                border
                style="width: 100%"
                class="tableContent"
            >
                <el-table-column
                    prop="consultName"
                    label="咨询分类"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="contactName"
                    label="联系人"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="contactPhone"
                    label="联系电话"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="申请人"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="content"
                    label="咨询内容"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="咨询时间"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    label="状态"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    prop="resContent"
                    label="反馈内容"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="showDetail(scope.row.uuid)">详情</el-button>
                    </template>
                </el-table-column>
                 <template slot="empty">
                     <img src="../../assets/暂无内容.jpg" alt="" style="width:200px">
                </template>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>

        </div>

        <consult-info-detail ref="dialogRef"></consult-info-detail>
    </div>
</template>

<script>
    import { getConsultInfoList,findConsultInfo } from "../../utils/consultInfo";
    import {getDictionaryItem} from "../../utils/interface";
    import consultInfoDetail from "./consultInfoDetail";

    export default {
        name: "consultInfo",
        data(){
            return{
                form: {},
                tabList: [
                    {
                        id: '0',
                        name: '我的咨询'
                    }
                ],
                tableList: [],
                current: 1,
                total: 0,
                pageSize: 10,
                loading: '',
                status: '',
                consultUuid: '',
                deliveryTypeList:[]
            }
        },
        created() {
            this.getList(),
            this.getDictionaryItem("consult_type")
        },
        components: {
            consultInfoDetail
        },
        methods: {
            getList(){
                this.loading = true

                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.status  = this.status;
                this.form.consultUuid = this.consultUuid;
                getConsultInfoList(this.form).then((res)=>{
                    if(res.success){
                        this.pageSize=res.pageSize;
                        this.total=res.total;
                        this.current =res.current;

                        res.data.map((item)=>{
                            this.deliveryTypeList.map((delivery)=>{
                                if(item.consultUuid == delivery.uuid){
                                    this.$set(item,'consultName',delivery.name)
                                }
                            })
                        })
                        this.tableList = res.data;
                    }
                });
            },
            handleCurrentChange(val){
                this.current = val
                this.getList()
            },
            reset(){
                this.status='';
                this.consultUuid='';
            },
            showDetail(uuid){
                this.$refs.dialogRef.init(this.deliveryTypeList,uuid);
            },
            getDictionaryItem(val){
                getDictionaryItem({groupCode: val}).then((res)=>{
                    this.deliveryTypeList = res
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .demand {
        padding: 20px;
        .releaseBox {
            background: #fff;
            padding: 35px;
            padding-top: 0;
            box-sizing: border-box;
            .releaseBoxTop {
                margin-bottom: 15px;
                h4 {
                    font-size: 18px;
                    color: #157efa;
                    margin-bottom: 18px;
                }
                .releaseBoxTopInput {
                    font-size: 14px;
                    color: #262626;
                    align-items: center;
                    margin-bottom: 20px;
                    /deep/.ql-toolbar.ql-snow {
                        display: none;
                    }
                    /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
                        border-top: 1px solid #ccc;
                    }
                    .releaseBoxTopInputBox {
                        flex-wrap: wrap;
                    }
                    input {
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        padding-left: 8px;
                        box-sizing: border-box;
                    }
                    .input2 {
                        width: 161px;
                        // margin-left: 90px;
                    }
                    textarea {
                        width: 614px;
                        height: 206px;
                        background: #f5f5f5;
                        opacity: 1;
                        border-radius: 6px;
                        border: none;
                        padding: 8px;
                        box-sizing: border-box;
                    }
                    /deep/.el-input--prefix .el-input__inner {
                        width: 161px;
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        //   padding-left: 8px;
                        box-sizing: border-box;
                        //   margin-left: 25px;
                    }
                    // /deep/.el-input__prefix {
                    //   right: -132px;
                    //   left: 0;
                    // }
                    /deep/.el-input__icon {
                        line-height: 30px;
                    }
                    .releaseBoxbotInputP {
                        width: 94px;
                        flex-shrink: 0;
                        white-space: nowrap;
                    }
                    .releaseBut {
                        background: #157efb;
                        color: #fff;
                    }
                    button {
                        width: 100px;
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        margin-right: 20px;
                        color: #262626;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }
        }

        .searchPart {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .tablePart {
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);

                    .num {
                        color: #356fdf;
                    }

                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157efb;
                        line-height: 30px;
                        text-align: center;

                        &:hover {
                            background: #157efb;
                            box-sizing: border-box;
                            border: 1px solid #157efb;
                            color: #fff;
                        }
                    }
                }

                .toolRight {
                    button {
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;

                        i {
                            padding-right: 5px;
                        }

                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }

            .tableContent {
                min-height: 650px;
                .complaintsimg {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i {
                        color: #108ee9;
                        margin-left: 10px;
                    }
                }
                /deep/ .el-table__header {
                    tr {
                        th {
                            // border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }

                    /deep/ .el-table__row {
                        td:first-child {
                            border-right: none;

                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
    /deep/.el-dialog__body {
        padding-top: 0;
    }
    .itemFlex {
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        .name {
            margin-left: 10px;
            /deep/p {
                margin: 0 !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/consultInfo/consultInfo.vue